import { createAsyncThunk } from "@reduxjs/toolkit";
import { calendarApi } from "../../services/api";

// Calendar categories (static for now)
const defaultCategories = [
  { id: 1, title: "New Event Planning", type: "success" },
  { id: 2, title: "Meeting", type: "info" },
  { id: 3, title: "Generating Reports", type: "warning" },
  { id: 4, title: "Create New theme", type: "danger" },
];

export const getEvents = createAsyncThunk("calendar/getEvents", async () => {
  try {
    const data = await calendarApi.getEvents();
    if (data.success) {
      return data.events;
    }
    return [];
  } catch (error) {
    console.error("Error fetching events:", error);
    return [];
  }
});

export const addNewEvent = createAsyncThunk("calendar/addNewEvent", async (event: any) => {
  try {
    const data = await calendarApi.createEvent({
      title: event.title,
      description: event.description || "",
      location: event.location || "",
      start: event.start instanceof Date ? event.start.toISOString() : event.start,
      end: event.end instanceof Date ? event.end.toISOString() : event.end || event.start,
      allDay: event.allDay || false,
      className: event.className || "bg-primary-subtle"
    });
    if (data.success) {
      return data.event;
    }
    return event;
  } catch (error) {
    console.error("Error adding event:", error);
    return event;
  }
});

export const updateEvent = createAsyncThunk("calendar/updateEvent", async (event: any) => {
  try {
    const data = await calendarApi.updateEvent(event.id, {
      title: event.title,
      description: event.description,
      location: event.location,
      start: event.start instanceof Date ? event.start.toISOString() : event.start,
      end: event.end instanceof Date ? event.end.toISOString() : event.end,
      allDay: event.allDay,
      className: event.className
    });
    if (data.success) {
      return event;
    }
    return event;
  } catch (error) {
    console.error("Error updating event:", error);
    return event;
  }
});

export const deleteEvent = createAsyncThunk("calendar/deleteEvent", async (eventId: any) => {
  try {
    const data = await calendarApi.deleteEvent(eventId);
    if (data.success) {
      return eventId;
    }
    return eventId;
  } catch (error) {
    console.error("Error deleting event:", error);
    return eventId;
  }
});

export const getCategories = createAsyncThunk("calendar/getCategories", async () => {
  // Return static categories
  return defaultCategories;
});

export const getUpCommingEvent = createAsyncThunk("calendar/getUpCommingEvent", async () => {
  try {
    const data = await calendarApi.getEvents();
    if (data.success) {
      // Filter upcoming events (within next 30 days)
      const now = new Date();
      const thirtyDaysLater = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
      return data.events.filter((event: any) => {
        const eventDate = new Date(event.start);
        return eventDate >= now && eventDate <= thirtyDaysLater;
      });
    }
    return [];
  } catch (error) {
    console.error("Error fetching upcoming events:", error);
    return [];
  }
});

export const resetCalendar = createAsyncThunk("calendar/resetCalendar", async () => {
  return '';
});
